const $ = require('jquery');
const headerAnalytics = require('header.analytics');
const config = {
  hfSupportLinkSelector: '.hf-support__link',
};

class HeaderTaskLinks {
  _logInteraction() {
    const text = $(this).text();

    return headerAnalytics.logEvent(
      'header click',
      ['header', 'task links', text].join('>'),
    );
  }

  init() {
    $(config.hfSupportLinkSelector).on('click', this._logInteraction);
  }
}

module.exports = new HeaderTaskLinks();
